import { type ComponentProps, type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionProps extends ComponentProps<'div'> {
  children: ReactNode
}

// Flat section block inside the unified panel surface — sections stack with
// hairline dividers instead of floating cards. Interactivity is owned by the
// containing region (for example, `SidepanelBody` covers the section stack).
export function SidepanelSection({ children, className, ...props }: SidepanelSectionProps) {
  return (
    <div className={twMerge('relative flex w-full flex-col gap-1.5 border-b px-3 py-4', className)} {...props}>
      {children}
    </div>
  )
}
